import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const blogApi = createApi({
  reducerPath: 'blogApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Blog'],
  endpoints: (builder) => ({
    getBlogs: builder.query({
      query: () => '/api/admin/getBlog',
      providesTags: ['Blog'],
    }),

    getBlogById: builder.query({
      query: (id) => `/api/admin/getBlogById/${id}`,
      providesTags: ['Blog'],
    }),

    addEditBlog: builder.mutation({
      query: (formData) => ({
        url: '/api/admin/addEditBlog',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Blog'],
    }),

    deleteBlog: builder.mutation({
      query: (id) => ({
        url: `/api/admin/deleteBlogbyId/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Blog'],
    }),
  }),
});

export const {
  useGetBlogsQuery,
  useGetBlogByIdQuery,
  useAddEditBlogMutation,
  useDeleteBlogMutation,
} = blogApi;
